import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Workspace from 'components/Workspace';
import GridBlock from 'components/GridBlock';
import Title from 'components/Title';

const style = theme => ({
	root: {

	},
	title: {
		marginBottom: theme.spacing(1)
	}
})

function Section({
	classes,
	title,
	children,
	titleAdditional,
}) {
	return (
		<Workspace
			className={classes.root}
		>
			<GridBlock column>
				<GridBlock justify='space-between'>
					<Title className={classes.title}>
						{title}
					</Title>
					{titleAdditional}
				</GridBlock>
				{children}
			</GridBlock>
		</Workspace>
	)
}

Section.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(Section);